import React, {useEffect, useState} from 'react';
import { useDispatch } from 'react-redux';
import {alertService} from '@app/services/alertService';

import {myService} from '@app/services/userService';
import Select from 'react-select';
import * as mainService from '@app/services/mainService';
import {useLocation} from 'react-router-dom';
import {getControllerName, getDefaultSelectValue} from '@app/utils/helpers';
import HeaderClick from '@app/utils/HeaderClick';
import {checkRole, createObj, updateObj} from '@app/services/mainService';
import {Button, Modal} from "react-bootstrap";
import {useSelector} from "react-redux";
import {Tabs} from "@components";
import {
    image_root  , INIT_ROLE_MENU
} from "@app/const/AppSetting";

import {useTranslation} from "react-i18next";
import MyReactDatePicker from "@app/utils/MyReactDatePicker";
import {findObjInArr} from "@app/utils/CommonFunctions";
import PhanquyenListComponent from '@app/pages/FUtil/PhanquyenListComponent';
import {ClipLoader} from "react-spinners";
import NhomnhanvienListComponent from "@pages/FUtil/NhomnhanvienListComponent";
function UserEdit({history, match}) {
    const [t] = useTranslation();
    const location = useLocation();
    const dispatch = useDispatch();

    const currController = getControllerName(location.pathname);
    const [loading, setLoading] = useState(false);
  
    let {id} = match.params;
    let isAddMode = !id;
    const isDisplay = id && location.pathname.indexOf(`view`) > 0;
    const [handleToogle, setHandleToogle] = useState(false);

    const [hasRole, setHasRole] = useState(false);
    const [roleMenu, setRoleMenu] = useState(INIT_ROLE_MENU);
   // const [listNhadan, setListNhadan] = useState([]);
   


    const initial = {
        id: id || 0,
        phanquyen_fks: [],
        ten : '',
        nhaphanphoi_fks : [],
        dang_nhap: '',
        mat_khau: '',
        mat_khau_xac_nhan:'',
        all: false
    };



    const [obj, setObj] = useState({...initial});





    const onChangeInput =  (e) => {
        const {name, value, checked} = e.target;


        if(name ==="xyz") {

          

        }
        else
        {
            setObj((prevState) => ({
                ...prevState,
                [name]: value
            }));
        }

        setHandleToogle((prevSelected) => {
            return !prevSelected;
        });

    };
   
    const createRs = async () => {

        if (!hasRole) {
            const role = await mainService.getRoleMENU(location.pathname);
            setRoleMenu(role);
            setHasRole(true);
        }

       
        
      
        
        if (!isAddMode) {
            myService.getById(id).then((response) => {
                console.log('getById', JSON.stringify(response, null, 2));

                if(!response || !response.data || !response.data.data)    
                {
                    history.push('/'+currController);
                    alertService.error('Thông tin theo Id không tồn tại hoặc không thuộc quyền của bạn');
                }

                let userX = response.data.data;

                setObj(userX);

            });
        }
        else
        {
            const cqtemp = await mainService.getAllNhaphanphoi({ path_access:currController});
            setObj((prevState) => ({
                ...prevState,
                nhaphanphoi_fks: cqtemp.map(obj=> ({ ...obj, checked: false }))
            }));
        }

    };

    useEffect(async () => {
       
         await checkRole({
                    pathname: location.pathname,
                    isAddMode,
                    currController,
                    history
                });

        await createRs();

    }, []);

    const saveClick = async () => {
        let data = obj;
        if(!data)
        {
            alert('Không xác định được trang vui lòng tải lại');
            return;
        }
       
        if(!data.ten || data.ten.length === 0)
        {
            alert('Vui lòng nhập tên');
            return;
        }
        if(!data.dang_nhap || data.dang_nhap.length === 0)
        {
            alert('Vui lòng nhập tên');
            return;
        }
        if(isAddMode)
        {
            if(!data.mat_khau || data.mat_khau.length === 0)
            {
                alert('Vui lòng nhập mật khẩu');
                return;
            }
                

        }
            
        if(data.mat_khau && data.mat_khau.length > 0)
        {
            if(!data.mat_khau_xac_nhan || data.mat_khau_xac_nhan.length === 0)
            {
                alert('Vui lòng nhập mật khẩu xác nhận');
                return;
            }
            if(data.mat_khau !== data.mat_khau_xac_nhan )
            {
                alert('Mật khẩu xác nhận không trùng khớp');
                return;
            }
        }   
                   
                


         isAddMode ?  createUser(data) : update(data);

    };
    



    const backBrowse = () => {
        history.push('/'+currController);
    };

    async function createUser(data) {
        setLoading(true);
        // delete data.ma;
        const result = await myService.Create(data);
        if (result.status ==="1") {
            alertService.success(result.msg);
            
            history.push('/'+currController);

        } else {
            alertService.error(result.msg);
        }
        setLoading(false);
    }
    async function update(data) {
        setLoading(true);
      
        const result = await myService.Update(id,data);



        if (result.status ==="1") {
            alertService.success(result.msg);

            setObj((prevState) => ({
                ...prevState,
                mat_khau: '',
                mat_khau_xac_nhan: ''
            }));

          
        } else {
            alertService.error(result.msg);
        }
        setLoading(false);
    }


    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50} />
            </div>
        );
    }

   

    let htmlButtonSave = '';

    if(isDisplay <= 0 || isAddMode > 0){
        htmlButtonSave = (
            <Button
            className="btn  btn-success  mr-1"
            
            icon="right fas fa-angle-left"
        onClick={saveClick}
         >
        <i className="fa fa-save"> {isAddMode>0 ? "Tạo mới" :"Cập nhật"  } </i>
         </Button>   
        );

    }
    const chonPK = (position,e) => {
        const {name, value, checked} = e.target;
        let q;
        let mAll;
        if(position === -1)
        {
            
            q = obj.nhaphanphoi_fks.map(obj=> ({ ...obj, checked: checked })) ;
            mAll = checked;
        }
        else
        {   
            q = obj.nhaphanphoi_fks;
            q[position]['checked']= checked;
            mAll = obj.all;
        }
        setObj((prevState) => ({
            ...prevState,
            nhaphanphoi_fks: q,
            all:mAll
        }));
        setHandleToogle((prevSelected) => {
            return !prevSelected;
        });

    };




    // eslint-disable-next-line no-shadow
    return (

        <div className="card card-primary">
            <HeaderClick
                headerName={roleMenu.tenmenu}
                isAddMode={isAddMode}
                isDisplay={isDisplay}
                history={history}
                currController={currController}
            />
            <div className="card-body">
                <div className="form-row p-2">
                    <Button className="btn btn-secondary  mr-1"  onClick={() => backBrowse()}>
                        <i className="fa fa-arrow-circle-left"> {t('action.label.back')}</i>
                    </Button>
                  {htmlButtonSave}

                </div>
                <div className="form-row p-2">
                
                </div>

                <div className="tab-pane fade show active" label="Thông tin bán hàng" id="thongtinnhanvien">
                    <div className="card-body">
                        <div className="row">
                            
                            
                            <div className="col-md-6">
                                <label>Tên</label>
                                    <input
                                        type='text'
                                        className="form-control"
                                        name="ten"
                                        id ="ten"
                                        value={obj.ten}
                                        onChange={(e) => onChangeInput( e)}
                                    />

                            </div>
                            <div className="col-md-6"> 
         
                            <label>Đăng nhập</label>
                                    <input
                                        type='text'
                                        className="form-control"
                                        name="dang_nhap"
                                        id ="dang_nhap"
                                        value={obj.dang_nhap}
                                        onChange={(e) => onChangeInput( e)}
                                    />
                      
                            </div>

                        </div>
                        <div className="row">
                            
                            
                            <div className="col-md-6">
                                <label>Mật khẩu</label>
                                    <input
                                        type='password'
                                        className="form-control"
                                        name="mat_khau"
                                        id ="mat_khau"
                                        value={obj.mat_khau}
                                        onChange={(e) => onChangeInput( e)}
                                    />

                            </div>
                            <div className="col-md-6">
                                <label>Xác nhận Mật khẩu</label>
                                    <input
                                        type='password'
                                        className="form-control"
                                        name="mat_khau_xac_nhan"
                                        id ="mat_khau_xac_nhan"
                                        value={obj.mat_khau_xac_nhan}
                                        onChange={(e) => onChangeInput( e)}
                                    />

                            </div>

                        </div>
                        <div className="row">
                            
                            <div className="col-md-6"> 
                            <PhanquyenListComponent isMulti = {true} phanquyen_fks = {obj.phanquyen_fks} 
                                                            onChange ={(opt, e) => {
                                                            const target = {name: "phanquyen_fks", value: opt};
                                                            onChangeInput({target}


                                                                
                                                            );

                                                        }}        /> 
                            </div>

                            <div className="col-md-6">
                                <NhomnhanvienListComponent
                                    nhomnhanvien_fk = {obj.nhomnhanvien_fk} onChange ={(opt, e) => {
                                    const target = {name: "nhomnhanvien_fk", value: opt?.value};
                                    onChangeInput({target});

                                }} />
                            </div>
                        </div>
                        <hr/>
                        <label>Phân quyền dữ liệu</label>
                        <div className="row table-responsive">
                                <div className="col-md-12">
                                    <table responsive bordered hover className="table table-bordered table-hover text-nowrap">
                                        <thead>
                                        <tr>
                                            <th className="col-md-1 text-center">ID</th>
                                            <th className="col-md-1 text-center">Tên</th>
                                            <th className="col-md-1 text-center">Chọn <input type="checkbox" id={`custom-checkbox-all`}
                                                                value={obj.all}
                                                                checked={obj.all}
                                                                onChange={(e) => chonPK(-1,e)}
                                                            /></th>
                                        </tr>
                                        </thead>
                                        <tbody>

                                        {
                                            obj.nhaphanphoi_fks.map((item, index) => {

                                                return (
                                                    <tr>
                                                        <td>{item.value}</td>
                                                        <td>{item.label} </td>

                                                        <td className="text-center">
                                                            <input type="checkbox" id={`custom-checkbox-${index }`}
                                                                value={item.checked}
                                                                checked={ obj.nhaphanphoi_fks[index]?.checked}
                                                                onChange={(e) => chonPK(index,e)}
                                                            />
                                                        </td>
                                                        
                                                    </tr>
                                                );


                                            })

                                        }
                                        </tbody>
                                    </table>
                            </div>

                        </div>
                    </div>
                </div>



            </div>
                        {/* /.card-body */}

            <div className="card-footer">
            </div>

          

        </div>



    );
}

export {UserEdit};
